mutation generateInitialTopics {
  topics: generateInitialTopics {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    landingpage {
      id
      slug
    }
  }
}
